import React, { Component } from 'react'
import { observer, Provider } from "mobx-react"
import DataChart from "./containers/DataChart"
import DataTable from "./containers/DataTable"
import Store from "app/stores/arrayPgt/dashboard"
import overviewIcon from "app/styles/images/sp/overview-selected.svg"

@observer
export default class index extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }
  render() {
    return (
      <Provider store={this.store}>
        <div className="pgd">
          <h2 className="page-title"><img alt="" src={overviewIcon} />总览</h2>
          <DataChart />
          <DataTable />
        </div>
      </Provider>
    )
  }
}




// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/dashboard/index.js